import { Controller } from '@hotwired/stimulus'

// Adds new rows to a single-level nested form (e.g. triage examples) by
// stamping a template's placeholder index and appending it to the list.
export default class extends Controller {
  static targets = ['list', 'item']

  addItem(e) {
    const template = e.currentTarget.dataset.template
    if (!template) return
    const html = template.replaceAll('__NEW_ITEM__', Date.now())
    this.listTarget.insertAdjacentHTML('beforeend', html)
  }
}
